import type { PortableTextBlock, Thumbnail } from "./globals.types";

export type Exercise = {
	_id: string;
	title: string;
	slug: string;
	video?: {
		slug: string;
		thumbnail?: Thumbnail;
		playbackId: string;
		duration: number;
		instructions?: PortableTextBlock[];
	};
} & (
	| {
			type: ExerciseType.STRENGTH_TRAINING;
			strengthTrainingFocus: StrengthTrainingFocus;
			stabilityScore: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
			velocityScore: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
	  }
	| {
			type: ExerciseType.CORRECTIVE_EXERCISE;
			correctiveExerciseFocus: CorrectiveExerciseFocus;
	  }
	| {
			type: ExerciseType.MANUAL_THERAPY;
			manualTherapyFocus: ManualTherapyFocus;
	  }
);

export enum StrengthTrainingFocus {
	TOTAL_BODY = "total_body",
	CHEST = "chest",
	BACK = "back",
	SHOULDERS = "shoulders",
	ARMS = "arms",
	LEGS = "legs",
}

export enum CorrectiveExerciseFocus {
	RELEASE = "release",
	MOBILIZATION = "mobilization",
	LENGTHENING = "lengthening",
	ISOLATED_ACTIVATION = "isolated_activation",
	REACTIVE_ACTIVATION = "reactive_activation",
	CORE_INTEGRATION = "core_integration",
	STABILITY_INTEGRATION = "stability_integration",
	SUBSYSTEM_INTEGRATION = "subsystem_integration",
	TAPING = "taping",
}

export enum ManualTherapyFocus {
	RELEASE = "release",
	MOBILIZATION = "mobilization",
	LENGTHENING = "lengthening",
	MANIPULATION = "manipulation",
	IASTM = "iastm",
	TAPING = "taping",
}

export enum ExerciseType {
	STRENGTH_TRAINING = "strength_training",
	CORRECTIVE_EXERCISE = "corrective_exercise",
	MANUAL_THERAPY = "manual_therapy",
}
